import type { ChannelsType } from 'ChannelsTabs/types'
import { selectChannelsType, selectSubListTypeSelected } from 'data/selectors'
import React, { memo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import DoneIcon from '@mui/icons-material/Done'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import type { PopoverOrigin } from '@mui/material/Popover'

import { changeSubListType } from './actions'
import { channelsOptions } from './constants'
import useStyles from './useStyles'

const anchorOrigin: PopoverOrigin = { horizontal: 'right', vertical: 'top' }
const transformOrigin: PopoverOrigin = { horizontal: 'right', vertical: 'top' }

function SubListTypeMenu() {
  const { t: translate } = useTranslation()
  const classes = useStyles()
  const dispatch = useDispatch()
  const channelType = useSelector(selectChannelsType)
  const subListTypeSelected = useSelector(selectSubListTypeSelected)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget)
  const handleClose = () => setAnchorEl(null)
  const MenuListProps = {
    classes: {
      root: classes.menuList,
    },
  }
  const onPick = (value: ChannelsType) => {
    handleClose()

    if (subListTypeSelected !== value) {
      dispatch(
        changeSubListType({
          channelType,
          value,
        }),
      )
    }
  }
  const menuItemClasses = {
    disabled: classes.disabled,
    root: classes.menuItem,
    selected: classes.selected,
  }

  return (
    <div>
      <IconButton className={classes.iconMore} onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={anchorOrigin}
        MenuListProps={MenuListProps}
        onClose={handleClose}
        classes={{ paper: classes.menu }}
        open={open}
        transformOrigin={transformOrigin}
      >
        {channelsOptions.map((option, index) => {
          const isSelected = option === subListTypeSelected
          const onClick = () => onPick(option)

          return (
            <div key={option}>
              {index > 0 && <Divider className={classes.divider} />}
              <MenuItem classes={menuItemClasses} disabled={channelType === option} selected={isSelected} onClick={onClick}>
                {translate(`channelsTabs.${option}`)}
                {isSelected && <DoneIcon className={classes.iconDone} />}
              </MenuItem>
            </div>
          )
        })}
      </Menu>
    </div>
  )
}

export default memo(SubListTypeMenu)
